'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgArrowUp, SvgBtStop } from '@common/icon';
import { cn } from '@core/utils';
import { type ChangeEvent, type KeyboardEvent, useEffect, useRef, useState } from 'react';
import styles from './ChatInput.module.scss';
export const CHAT_INPUT_BAR_ID = 'wello-agent-input-bar';
const TEXTAREA_MAX_HEIGHT = 144;
interface ChatInputProps {
  isStreaming?: boolean;
  isAwaitingSession?: boolean;
  onSubmit: (message: string) => void;
  onStop?: () => void;
}
export const ChatInput = t0 => {
  const $ = _c(28);
  const {
    isStreaming: t1,
    isAwaitingSession: t2,
    onSubmit,
    onStop
  } = t0;
  const isStreaming = t1 === undefined ? false : t1;
  const isAwaitingSession = t2 === undefined ? false : t2;
  const [value, setValue] = useState("");
  const textareaRef = useRef(null);
  const isBusy = isStreaming || isAwaitingSession;
  let t3;
  if ($[0] !== isBusy || $[1] !== value) {
    t3 = isBusy || !value.trim();
    $[0] = isBusy;
    $[1] = value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isSendDisabled = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEffect(_temp, t4);
  const syncTextareaHeight = _temp2;
  let t5;
  if ($[4] !== isSendDisabled || $[5] !== onSubmit || $[6] !== value) {
    t5 = () => {
      if (isSendDisabled) {
        return;
      }
      onSubmit(value.trim());
      setValue("");
      if (textareaRef.current) {
        textareaRef.current.style.height = "";
      }
    };
    $[4] = isSendDisabled;
    $[5] = onSubmit;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const submit = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => {
      setValue(event.target.value);
      syncTextareaHeight(event.target);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleChange = t6;
  let t7;
  if ($[9] !== submit) {
    t7 = event_0 => {
      if (event_0.nativeEvent.isComposing || event_0.key !== "Enter" || event_0.shiftKey) {
        return;
      }
      event_0.preventDefault();
      submit();
    };
    $[9] = submit;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleKeyDown = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("w-full rounded-xxlarge border border-Gray-200 bg-Gray-white p-10 shadow-md-reverse transition-colors focus-within:border-transparent mobile-tablet:rounded-t-large mobile-tablet:border-x-0 mobile-tablet:border-b-0 mobile-tablet:px-20 mobile-tablet:py-12 mobile-tablet:focus-within:border-Gray-400", styles.gradientRing);
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== submit) {
    t9 = event_1 => {
      event_1.preventDefault();
      submit();
    };
    $[12] = submit;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== handleKeyDown || $[15] !== value) {
    t10 = <div className="flex min-h-52 flex-1 items-end rounded-xlarge bg-Gray-100 px-16 py-12 mobile-tablet:min-h-40 mobile-tablet:bg-Gray-200 mobile-tablet:py-8"><textarea ref={textareaRef} aria-label={"\uC6F0\uB85C AI\uC5D0\uAC8C \uBA54\uC2DC\uC9C0 \uC785\uB825"} className="max-h-144 min-h-24 flex-1 resize-none overflow-y-auto bg-transparent py-2 text-Gray-900 typo-body3 placeholder:text-Gray-550 focus:outline-none mobile-tablet:typo-body4" id="wello-agent-message" maxLength={1000} name="message" placeholder={"\uC815\uCC45\uC5D0 \uB300\uD574 \uBB3C\uC5B4\uBCF4\uC138\uC694"} rows={1} value={value} onChange={handleChange} onKeyDown={handleKeyDown} /></div>;
    $[14] = handleKeyDown;
    $[15] = value;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isSendDisabled || $[18] !== isStreaming || $[19] !== onStop) {
    t11 = isStreaming ? <button aria-label={"\uB2F5\uBCC0 \uC0DD\uC131 \uBA48\uCD94\uAE30"} className="mb-4 flex size-40 shrink-0 items-center justify-center rounded-pill bg-Gray-black transition-colors hover:bg-Gray-900 mobile-tablet:mb-2 mobile-tablet:size-32" type="button" onClick={onStop}><SvgBtStop className="size-16 text-Gray-white mobile-tablet:size-14" /></button> : <button aria-label={"\uBA54\uC2DC\uC9C0 \uBCF4\uB0B4\uAE30"} className={cn("mb-4 flex size-40 shrink-0 items-center justify-center rounded-pill transition-colors mobile-tablet:mb-2 mobile-tablet:size-32", isSendDisabled ? "cursor-not-allowed bg-Gray-200" : "bg-Gray-black hover:bg-Gray-900")} disabled={isSendDisabled} type="submit"><SvgArrowUp className={cn("size-18 mobile-tablet:size-16", isSendDisabled ? "text-Gray-550" : "text-Gray-white")} /></button>;
    $[17] = isSendDisabled;
    $[18] = isStreaming;
    $[19] = onStop;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t9) {
    t12 = <div className={t8} id={CHAT_INPUT_BAR_ID}><form className="flex items-center gap-8" onSubmit={t9}>{t10}{t11}</form></div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="pt-8 text-center text-Gray-500 typo-caption2 mobile-tablet:px-16 mobile-tablet:pb-8">웰로 AI의 답변은 정확하지 않을 수 있어요</p>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <>{t12}{t13}</>;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
function _temp() {
  const inputBar = document.getElementById(CHAT_INPUT_BAR_ID);
  const composer = inputBar?.closest(".fixed");
  if (!composer) {
    return;
  }
  const publishHeight = () => {
    document.documentElement.style.setProperty("--wello-agent-composer-h", `${(composer as HTMLElement).offsetHeight}px`);
  };
  const observer = new ResizeObserver(publishHeight);
  observer.observe(composer);
  publishHeight();
  return () => {
    observer.disconnect();
    document.documentElement.style.removeProperty("--wello-agent-composer-h");
  };
}
function _temp2(textarea) {
  textarea.style.height = "0px";
  textarea.style.height = `${Math.min(textarea.scrollHeight, TEXTAREA_MAX_HEIGHT)}px`;
}